export enum ZapType {
  DUAL = "DUAL",
  LP = "LP",
  ZAP = "ZAP",
}
